import { Link, Typography } from 'omakase';
import { getAutoFormatSrcAndSrcSetForWidthPx } from '@tock/images';
import { isIOSNative } from 'utils/deviceUtils';
import { layout } from 'components/business/receipts/OfferingSummary/offeringSummaryTitleCssDefs';

export interface OfferingSummaryTitleProps {
  /**
   * Link destination, applied to the business name
   */
  href?: string;
  /**
   * Thumbnail image
   */
  imgSrc?: string | null;
  /**
   * Alt text applied to the thumbnail image
   */
  imgAlt?: string | null;
  /**
   * Display name of the business
   */
  businessName: string;
  /**
   * Display name of the offering
   */
  offeringName: string;
}

/**
 * Business + experience name lockup.
 */
export const OfferingSummaryTitle: React.FC<OfferingSummaryTitleProps> = ({
  businessName,
  href,
  imgAlt,
  imgSrc,
  offeringName,
}) => {
  const { src, srcSet } = getAutoFormatSrcAndSrcSetForWidthPx({ width: 72 }, imgSrc ?? undefined);
  const altText = imgAlt ?? businessName;
  const title = (
    <OfferingSummaryHeadline businessName={businessName} offeringName={offeringName} href={href} />
  );

  if (!src) {
    return title;
  }

  return (
    <div css={layout}>
      <img src={src} srcSet={srcSet} alt={altText} />
      {title}
    </div>
  );
};

const OfferingSummaryHeadline: React.FC<
  Pick<OfferingSummaryTitleProps, 'businessName' | 'offeringName' | 'href'>
> = ({ businessName, href, offeringName }) => {
  return (
    <div>
      <Typography variant="heading04" data-testid="bussiness-name">
        {href && !isIOSNative() ? <Link href={href}>{businessName}</Link> : businessName}
      </Typography>
      <Typography variant="body02" noWrap data-testid="experience-info">
        {offeringName}
      </Typography>
    </div>
  );
};
